import Logo from '../assets/kinsta-logo.png'

const Header = () => {
    return (
        <img style={{width:"27%"}} src={Logo} alt="Kinsta Logo" className="kinsta-logo" />
    )
}

export default Header